import _axios from 'axios'
const API_URL = 'https://api.tally.xyz/query'

const axios = _axios.create({
  baseURL: API_URL,
  timeout: 15000,
})

interface IOokiProposals {
  governance: {
    id: string
    organization: { visual: { icon: string } }
    quorum: 'string'
    stats: { proposals: { failed: number; passed: number } }
  }
  proposals: {
    id: string
    description: string
    statusChanges: { type: string }[]
    voteStats: {
      percent: number
      support: 'FOR' | 'AGAINST' | 'ABSTAIN'
      votes: string
      weight: string
    }[]
  }[]
}

/**
 * Try to get the original error message from server.
 * @param {Error} error Error from a request
 */
function normalizeRequestError(error: any) {
  if (error && error.response && error.response.data) {
    const errorData = error.response.data
    if (errorData.message) {
      error.message = errorData.message
    }
    if (errorData.errorCode) {
      error.code = errorData.errorCode
    }
  }
  return error
}

async function getOokiProposals(): Promise<IOokiProposals> {
  const query = {
    query: `
    query GovernanceProposals($sort: ProposalSort, $chainId: ChainID!, $pagination: Pagination, $governanceId: AccountID!, $governanceIds: [AccountID!], $proposerIds: [AccountID!]) {
      proposals(
        sort: $sort
        chainId: $chainId
        pagination: $pagination
        governanceIds: $governanceIds
        proposerIds: $proposerIds
      ) {
        id
        description
        statusChanges {
          type
        }
        tallyProposal {
          id
          createdAt
          status
        }
        voteStats {
          votes
          weight
          support
          percent
        }
      }
      governance(id: $governanceId) {
        id
        quorum
        organization {
          visual {
            icon
        }
      }
      stats {
          proposals {
            passed
            failed
          }
      }
    }}
      `,
    variables: {
      pagination: { limit: 5, offset: 0 },
      sort: { field: 'START_BLOCK', order: 'DESC' },
      chainId: 'eip155:1',
      governanceId: 'eip155:1:0x3133b4F4dcffc083724435784fEFAD510FA659c6',
      governanceIds: ['eip155:1:0x3133b4F4dcffc083724435784fEFAD510FA659c6'],
    },
  }
  try {
    const { data } = await axios.post('', query)
    return data.data
  } catch (err) {
    throw normalizeRequestError(err)
  }
}

export default {
  getOokiProposals,
}
